import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';

import { ProcessoService, TipoAposentadoria } from '../../core/services/processo.service';
import { STATUS_BENEFICIO } from '../../core/services/analise-processo.service';
import { SessionService } from '../../core/services/session.service';

@Component({
  standalone: true,
  selector: 'app-pesquisar-processo',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTableModule,
  ],
  templateUrl: './pesquisar-processo.component.html',
  styleUrl: './pesquisar-processo.component.scss',
})
export class PesquisarProcessoComponent implements OnInit {
  public form!: FormGroup;
  public loading = false;

  public processos: any[] = [];
  public displayedColumns: string[] = [
    'numProc',
    'nome',
    'matricula',
    'tipo',
    'orgao',
    'localAtual',
    'status',
    'dataAbertura',
    'diasLocal',
    'acoes',
  ];

  public page = 0;
  public maxpage = 10;
  public length = 0;

  public tiposBeneficio: { label: string; value: TipoAposentadoria }[] = [
    { label: 'Reserva remunerada - a pedido', value: 'RESERVA_REMUNERADA_A_PEDIDO' },
    { label: 'Reserva remunerada - ex officio', value: 'RESERVA_REMUNERADA_EX_OFFICIO' },
    { label: 'Reforma por incapacidade', value: 'REFORMA_POR_INCAPACIDADE' },
    { label: 'Reforma por idade', value: 'REFORMA_POR_IDADE' },
    { label: 'Reforma por tempo de contribuição', value: 'REFORMA_POR_TEMPO_DE_CONTRIBUICAO' },
  ];

  public statusOpcoes = STATUS_BENEFICIO;

  public orgaos: { label: string; value: number }[] = [];

  public locaisAtuais: { label: string; value: number }[] = [];

  constructor(
    private fb: FormBuilder,
    private processoService: ProcessoService,
    private sessionService: SessionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.processoService.listarOrgaos().subscribe({next: orgaos => this.orgaos = orgaos});
    this.processoService.listarLocais().subscribe({ next: locais => this.locaisAtuais = locais.map(l => ({ label: l.descricao || l.nome, value: l.id })) });
    this.form = this.fb.group({
      numBen: [''],
      cpf: [''],
      servidor: [''],
      tipo: [''],
      status: [''],
      numProc: [''],
      matricula: [''],
      idOrgao: [''],
      idLocalAtual: [''],
      ultimoDespachoUsuario: [false],
    });
  }

  public pesquisar(): void {
    this.loading = true;
    const v = this.form.value;

    this.processoService
      .pesquisarProcessos(this.page, this.maxpage, {
        tipo: v.tipo,
        status: v.status,
        numProc: v.numProc,
        numBen: v.numBen,
        matricula: v.matricula,
        idOrgao: v.idOrgao,
        idLocalAtual: v.idLocalAtual,
        cpf: v.cpf,
        nome: v.servidor,
      })
      .subscribe({
        next: (res: any) => {
          this.processos = res?.results ?? res?.content ?? res ?? [];
          this.length = res?.total ?? res?.totalElements ?? this.processos.length;
          this.loading = false;
        },
        error: (err) => {
          console.error('Erro ao pesquisar processos', err);
          this.loading = false;
        },
      });
  }

  public limpar(): void {
    this.form.reset({ ultimoDespachoUsuario: false });
    this.processos = [];
    this.length = 0;
    this.page = 0;
  }

  public onPageChange(event: PageEvent): void {
    this.page = event.pageIndex;
    this.maxpage = event.pageSize;
    this.pesquisar();
  }

  public abrirProcesso(processo: any): void {
    const id = processo?.idBeneficio ?? processo?.id ?? processo?.idProcesso;
    if (id == null) {
      console.warn('Processo sem id identificável', processo);
      return;
    }
    this.router.navigate(['/processo', id]);
  }

  public labelTipo(value: string): string {
    return this.tiposBeneficio.find((t) => t.value === value)?.label ?? value ?? '';
  }

  public labelStatus(value: string): string {
    return this.statusOpcoes.find((s) => s.value === value)?.label ?? value ?? '';
  }

  public labelOrgao(value: any): string {
    return this.orgaos.find((o) => o.value === Number(value))?.label ?? value ?? '';
  }

  public labelLocalAtual(value: any): string {
    return this.locaisAtuais.find((l) => l.value === Number(value))?.label ?? value ?? '';
  }
}
